import type { MapperOptions } from '~/types/index.js'
import { mapperModuleMediaCard } from '../../modules/mappers.js'

/**
 * Page contact detail mapper
 * normalizes data to be used in pages
 * @param {Object} data - cms data
 * @return {Object} - normalized page data
 */
export const mapperPageContactThankYou = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    description: data.description || '',
    pointsOfContactItems:
      data.pointsOfContactCollection?.items.map((item: any) => mapperModuleMediaCard(item, options)) || []
  }
}
